import { DraftPreviewProvider } from './DraftPreviewProvider';
import { Root } from './Root';
export function DraftPreview(props) {
    const { composerId, onClose, onGoBack } = props;
    return (<DraftPreviewProvider composerId={composerId} onClose={onClose} onGoBack={onGoBack}>
      <Root />
    </DraftPreviewProvider>);
}
